<template>
	<div class="d-flex justify-content-center spinner-container">
		<div class="spinner-border purpleText" role="status">
			<span class="visually-hidden-focusable">Loading...</span>
		</div>
	</div>
</template>

<script>

import oidc from "../services/oidc.js";

export default {
	name: "Callback",
	components: {

	},

	async mounted() {
		console.log(oidc.userManager);
		if (oidc.userManager == null || oidc.userManager == undefined) {
			oidc.configureUserManager();
		}
		oidc.handleLoginCallback();
	}
};
</script>

<style scoped lang="scss">
	@import '../styles.scss';
</style>
